import { useAuth } from "@/hooks/useAuth";
import { getBrands } from "@/utils/campaigns";
import { useQuery } from "@tanstack/react-query";

const transformBrandsData = (data) => {
  return data?.data?.map((item) => ({
    label: item?.attributes?.name, // Safely access name
    value: item?.id?.toString(), // Convert ID to string
    type: item?.attributes?.type,
  }));
};


export default function useBrands() {
  const { org } = useAuth();

  const fetchBrands = async () => {
    if (!org?.id) return [];
    const response = await getBrands(org.id);
    return response;
  };

  const { data: brands, isLoading } = useQuery({
    queryKey: ['brands', org?.id],
    queryFn: fetchBrands,
    enabled: !!org?.id, 
    staleTime: 5 * 60 * 1000, 
    select: transformBrandsData, 
  });

  return { brands, isLoading };
}


